import awakingImg from '@/static/assets/customer_reviews/pics/tweet_face_awaking.png';
import brentImg from '@/static/assets/customer_reviews/pics/tweet_face_brent.png';
import jakobImg from '@/static/assets/customer_reviews/pics/tweet_face_jakob.png';
import jenniferImg from '@/static/assets/customer_reviews/pics/tweet_face_jennifer.png';
import mariaImg from '@/static/assets/customer_reviews/pics/tweet_face_maria.png';
import rashiqImg from '@/static/assets/customer_reviews/pics/tweet_face_rashiq.png';

export const tweets = [
  {
    name: 'Jakob Wahlers',
    handle: 'jakobwahlers',
    img: jakobImg,
    text: 'Großes Lob an <span class="primary">@Lemonade_Inc</span>! So einfach, fair und transparent habe ich noch keine Versicherung abgeschlossen. <span class="primary">#insurance #Digitalisierung #papierlos</span>',
  },
  {
    name: 'Rashiq in SF',
    handle: 'rashiq',
    img: rashiqImg,
    text: '<span class="primary">@Lemonade_Inc</span> - wow, zweifellos das beste Versicherungserlebnis, das ich je hatte! Heißer Scheiß! Ich liebe eure App.',
  },
  {
    name: 'Brent',
    img: brentImg,
    handle: 'goforbrent',
    text: '<span class="primary">@Lemonade_Inc</span> war die einfachste Versicherung, die ich jemals abgeschlossen  habe. "Traditionelle" Versicherungsunternehmen müssen einen Schritt ins aktuelle Jahrhundert machen!!!',
  },
  {
    name: 'Jennifer Troyer',
    img: jenniferImg,
    handle: 'jennifer_troyer',
    text: 'Habe erst heute Morgen von <span class="primary">@Lemonade_Inc</span> gehört und schon haben sie einen neuen Kunden. Ich schwöre, es war eine der angenehmsten Onboarding-Erfahrungen, die ich… vielleicht je hatte. Ich will es irgendwie nochmal machen. Klasse!',
  },
  {
    name: 'Maria Salamanka',
    handle: 'MariaSalamankaM',
    img: mariaImg,
    text: 'Bin immer enttäuscht, wie sehr Versicherungen bei einem Schadensfall gegen die eigenen Kunden vorgehen. Hatte gerade meine erste gute Erfahrung bei der Meldung eines Schadens. Unglaublich schnelles und zuverlässiges Kundenerlebnis <span class="primary">@Lemonade_Inc</span>.',
  },
  {
    name: 'AWaking Dream',
    handle: 'AWaking_Dream',
    img: awakingImg,
    text: 'Alle 2-3 Jahre stolpere ich über eine wirklich herausragende App / Unternehmen, das einfach alles geschafft hat. Nutzererlebnis, Preis, Kundenservice - <span class="primary">@Lemonade_Inc</span> - alles da und ich finde es echt toll: <span class="primary">www.lemonade.com/de</span>',
  },
];
